import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';
import { get } from 'lodash-es';

import Skeleton from '../../../../Skeleton';
import ErrorStateWithReload from '../../../../ErrorStateWithReload';
import InsightsCardBox from '../../../../../pages/app-insights/_shared/components/InsightsCardBox';
import YearChart from '../../../../../pages/app-insights/_shared/components/YearChart';

import { permissionsSelector } from '../../../selectors';
import { getMetricLabel } from '../../../../../pages/app-insights/_shared/config/finance/metrics';

const widgetKeys = ['growth', 'engagement'];

const activeMetric = {
  growth: 'downloads',
  engagement: 'dau',
};

const widgetTitles = {
  growth: 'New user growth',
  engagement: 'Engagement',
};

const CombineView = ({
  widgets,
  settings,
  maxDate,
}) => {
  const decoratedwidgetTitles = {
    ...widgetTitles,
    growth: 'Growth',
  };

  return (
    <div className="finance-granularity-chart-widgets combine-view">
      <InsightsCardBox
        bodyMinHeight={619}
        className="app-overview-performance"
        headerLeft={(
          <h4 className="h4">
            All Users
          </h4>
        )}
      >
        {!settings.pending && settings.error && <ErrorStateWithReload /> }
        {!settings.error && (
          <div className="chart-wrapper">
            {widgetKeys.map((widget, index) => (
              <Fragment key={widget}>
                <div className="year-chart">
                  <div className="filters-section">
                    <div className="chart-caption">
                      {decoratedwidgetTitles[widget]} — {getMetricLabel(activeMetric[widget], widget)}
                      <span className="chart-caption__append">YoY</span>
                    </div>
                  </div>
                  {settings.pending && <Skeleton height={276} width="100%" />}
                  {!settings.pending && (
                    <YearChart
                      series={get(widgets, ['performance', 'year_over_year'])}
                      metric={activeMetric[widget]}
                      granularity="weekly"
                      overPeriod="year-over-year"
                      rotateLabels
                      variant="qv"
                      maxDate={maxDate}
                      subDates={get(widgets, ['performance', 'year_sub_dates'])}
                    />
                  )}
                </div>
                {(index !== widgetKeys.length - 1) && <div className="divider b-b" />}
              </Fragment>
            ))}
          </div>
        )}
      </InsightsCardBox>
    </div>
  );
};

CombineView.propTypes = {
  widgets: T.object.isRequired,
  settings: T.object.isRequired,
  maxDate: T.string,
};

const FinanceGranularityChartWidgets = ({ widgets, settings }) => {
  const permissions = useSelector(permissionsSelector);

  return (
    <CombineView
      widgets={widgets}
      settings={settings}
      maxDate={permissions.maxDate}
    />
  );
};

FinanceGranularityChartWidgets.propTypes = {
  widgets: T.object.isRequired,
  settings: T.object.isRequired,
};

export default FinanceGranularityChartWidgets;
